/* Les deux finitions que le thème source rendait par son propre moteur.

   On a remplacé leur global.js — il vérifie le domaine auprès de son éditeur
   et refuse de s'exécuter ailleurs que chez eux. Deux affichages en
   dépendaient : la fourchette de livraison et la notation en tête de fiche. */
(() => {
  /* Certaines pages appellent ce fichier deux fois — une fois par la coquille,
     une fois par la page reprise elle-même. On ne le joue qu'une. */
  if (window.__tkFinitions) return;
  window.__tkFinitions = true;

  /* ── la fourchette de livraison ────────────────────────────────────── */
  const JOURS = (bloc) => bloc.dataset.dayLabels.split(',').map((j) => j.trim());
  const MOIS = (bloc) => bloc.dataset.monthLabels.split(',').map((m) => m.trim());


  /* En jours ouvrés, pas en jours calendaires : la boutique annonce partout
     « business days ». Compter les week-ends revenait à promettre deux à trois
     jours de moins que la politique affichée. */
  function dans(jours) {
    const d = new Date();
    let restants = jours;
    while (restants > 0) {
      d.setDate(d.getDate() + 1);
      const j = d.getDay();
      if (j !== 0 && j !== 6) restants -= 1;
    }
    return d;
  }

  document.querySelectorAll('.estimated-shipping[data-text]').forEach((bloc) => {
    const jours = JOURS(bloc);
    const mois = MOIS(bloc);
    const dire = (d) =>
      `${jours[(d.getDay() + 6) % 7]}, ${mois[d.getMonth()]} ${d.getDate()}`;

    const texte = bloc.dataset.text
      .replace('[start_date]', dire(dans(+bloc.dataset.minDays)))
      .replace('[end_date]', dire(dans(+bloc.dataset.maxDays)));

    const cible = bloc.querySelector('.estimated-shipping__text') || bloc;
    const p = document.createElement('div');
    p.className = 'estimated-shipping__text';
    p.innerHTML = texte;
    if (cible === bloc) bloc.appendChild(p);
    else cible.replaceWith(p);
  });

  /* ── la notation en tête de fiche ──────────────────────────────────── */
  const ETOILE =
    'M24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164' +
    '.015.289a.85.85 0 0 1-.151.511.51.51 0 0 1-.44.21c-.183 0-.375-.058-.577-' +
    '.174L12 19.869l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-' +
    '.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-' +
    '5.106C.12 9.858 0 9.627 0 9.425c0-.356.269-.577.808-.664l7.24-1.052L11.29.' +
    '96c.183-.395.418-.593.71-.593.29 0 .526.198.71.593l3.24 6.749 7.242 1.052' +
    'c.538.087.807.308.807.664Z';

  document.querySelectorAll('.loox-rating[data-rating]').forEach((bloc) => {
    if (bloc.children.length) return;
    const note = parseFloat(bloc.dataset.rating);
    const nombre = Number(bloc.dataset.raters).toLocaleString('en-CA');
    const libelle = (bloc.dataset.pattern || '[count]').replace('[count]', nombre);

    bloc.style.fontSize = (bloc.dataset.contentSize || 14) + 'px';
    bloc.title = libelle;
    bloc.setAttribute('aria-label', libelle);
    bloc.setAttribute('role', 'figure');

    const contenu = document.createElement('div');
    contenu.className = 'loox-rating-content';
    for (let i = 0; i < 5; i += 1) {
      contenu.insertAdjacentHTML('beforeend',
        `<svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${i < Math.round(note) ? 'full' : 'empty'}" ` +
        `aria-hidden="true"><path fill="currentcolor" d="${ETOILE}"></path></svg>`);
    }
    contenu.insertAdjacentHTML('beforeend',
      `<span class="loox-rating-label" aria-hidden="true">&nbsp;${libelle}</span>`);
    bloc.appendChild(contenu);
  });

  /* ── la barre d'achat se montre dès qu'on défile ──────────────────
     Le thème la masque par « [data-after-scroll=true] », attribut que leur
     application retirait au défilement. Cette application n'est plus là.
     Un IntersectionObserver ne se déclenche pas ici — le <body> porte
     « overflow: hidden auto » et la fenêtre n'est pas le conteneur qui
     défile. On écoute donc le défilement, ce qui marche partout. */
  {
    const barreAchat = document.querySelector('sticky-atc');
    if (barreAchat) {
      const scroller = document.scrollingElement || document.documentElement;
      const position = () =>
        window.scrollY || scroller.scrollTop || document.body.scrollTop || 0;
      let affichee = null;
      const rafraichir = () => {
        const montrer = position() > 120;
        if (montrer === affichee) return;
        affichee = montrer;
        if (montrer) barreAchat.removeAttribute('data-after-scroll');
        else barreAchat.setAttribute('data-after-scroll', 'true');
      };
      rafraichir();
      let enAttente = false;
      const surDefilement = () => {
        if (enAttente) return;
        enAttente = true;
        requestAnimationFrame(() => { enAttente = false; rafraichir(); });
      };
      addEventListener('scroll', surDefilement, { passive: true });
      document.body.addEventListener('scroll', surDefilement, { passive: true });
      addEventListener('resize', surDefilement);

      // Le bouton de la barre relaie le clic sur le vrai bouton d'ajout :
      // l'identifiant du formulaire change d'une fiche à l'autre, un
      // attribut « form » écrit en dur ne marcherait que sur une seule.
      const relais = barreAchat.querySelector('[data-relais-achat]');
      const vrai = [...document.querySelectorAll(
        '.atc-button, .product-form__submit, button[name="add"]')]
        .find((b) => !b.closest('sticky-atc'));
      if (relais && vrai) relais.addEventListener('click', () => vrai.click());
    }
  }

  /* ── la barre d'achat réserve sa place sous le pied de page ────────── */
  const barre = document.querySelector('sticky-atc');
  const pied = document.querySelector('.footer');
  if (barre && pied) {
    // La mesure était prise une seule fois, avant que toutes les feuilles de
    // style soient appliquées : on réservait 209 px pour une barre qui n'en
    // fait que 98, d'où une bande blanche en bas de page. On observe donc la
    // barre : quoi qu'il arrive à sa hauteur, la réserve suit.
    const reserver = () => {
      const h = Math.round(barre.offsetHeight);
      // Marge INTÉRIEURE, pas extérieure : en marge extérieure la place
      // réservée tombe hors du pied et prend le blanc de la page — c'est la
      // bande blanche qu'on voyait tout en bas. En marge intérieure elle
      // prend le noir du pied et ne se voit plus.
      if (h > 0) pied.style.paddingBottom = h + 'px';
    };
    pied.style.marginBottom = '';
    reserver();
    addEventListener('resize', reserver);
    addEventListener('load', reserver);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserver);
    if (window.ResizeObserver) new ResizeObserver(reserver).observe(barre);
  }

  /* ── le macaron de confiance (page d'accueil) ──────────────────────── */
  document.querySelectorAll('.loox-trust-badge-container[data-loox-rating]').forEach((bloc) => {
    if (bloc.children.length) return;
    const note = parseFloat(bloc.dataset.looxRating);
    const nombre = Number(bloc.dataset.looxRaters).toLocaleString('en-CA');
    const titre = bloc.dataset.looxReviewTitle || 'reviews';

    const etoiles = Array.from({ length: 5 }, (_, i) =>
      `<svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${i < Math.round(note) ? 'full' : 'empty'}" ` +
      `aria-hidden="true"><path fill="currentcolor" d="${ETOILE}"></path></svg>`).join('');

    bloc.style.display = 'flex';
    bloc.innerHTML =
      `<div class="loox-trust-badge-widget lxs-paper" data-lxs-variant="outlined"
            style="--lxs-paper-border-radius: ${bloc.dataset.looxBorderRadius || 6}px; font-size: ${bloc.dataset.looxFontSize || 12}px;">
         <div class="loox-trust-badge-widget-content-container" tabindex="0" role="button">
           <div class="loox-trust-badge-widget-content">
             <div class="loox-trust-badge-widget-ratings">
               <div class="loox-trust-badge-widget-ratings__stars loox-rating">
                 <div class="loox-rating-content">${etoiles}</div>
               </div>
               <div class="loox-trust-badge-widget-ratings__average-rating">${note}/5</div>
             </div>
             <div class="loox-trust-badge-widget-ratings__raters" title="${nombre} ${titre}">
               <div class="loox-trust-badge-widget-ratings__raters-count">${nombre}</div>
               <div class="loox-trust-badge-widget-ratings__raters-title">${titre}</div>
             </div>
           </div>
         </div>
       </div>`;

    if (bloc.dataset.looxOpenReviews === 'true') {
      bloc.style.cursor = 'pointer';
      bloc.addEventListener('click', () => {
        const cadre = document.getElementById('cadre-avis');
        if (cadre) cadre.scrollIntoView({ behavior: 'smooth' });
        else window.location.href = '/products/haulm-supply-overhead-storage#cadre-avis';
      });
    }
  });

  /* ── les vidéos de démonstration ───────────────────────────────────── */
  /* Chez eux, <internal-video data-autoplay="true"> lance la lecture quand la
     vidéo entre dans l'écran, et la met en pause quand elle en sort. Leur
     moteur de thème ne tourne pas ici : on refait ce comportement. */
  const videos = document.querySelectorAll('internal-video[data-autoplay="true"] video, video[loop][muted]');
  if (videos.length && 'IntersectionObserver' in window) {
    const veilleur = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) {
          v.muted = true;
          const essai = v.play();
          if (essai && essai.catch) essai.catch(() => {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    videos.forEach((v) => {
      v.muted = true;
      v.setAttribute('playsinline', '');
      veilleur.observe(v);
    });
  }

  /* ── la galerie produit ────────────────────────────────────────────── */
  /* Les vues 2 à 11 portent loading="lazy". Dans un carrousel horizontal,
     le navigateur ne les charge que si elles croisent la fenêtre — ce qui
     n'arrive jamais : cliquer une vignette rendait la vue active mais
     blanche. On force donc le chargement de la vue choisie et de ses
     voisines, et on précharge le reste une fois la page tranquille. */
  const galerie = document.querySelector('media-gallery');
  if (galerie) {
    const vues = () => [...galerie.querySelectorAll('.product__media-item')];

    const charger = (vue) => {
      const im = vue && vue.querySelector('img');
      if (!im || im.dataset.forcee) return;
      im.dataset.forcee = '1';
      im.loading = 'eager';
      if (!im.complete || !im.naturalWidth) {
        const src = im.getAttribute('src');
        if (src) im.setAttribute('src', src);
      }
    };

    const autour = () => {
      const liste = vues();
      const i = liste.findIndex((v) => v.classList.contains('is-active'));
      [liste[i], liste[i + 1], liste[i - 1]].forEach(charger);
    };

    galerie.addEventListener('click', () => {
      requestAnimationFrame(autour);
      setTimeout(autour, 120);
    });
    galerie.addEventListener('keyup', () => setTimeout(autour, 120));

    // filet de sécurité : au bout d'un instant, tout le carrousel est prêt
    const precharger = () => setTimeout(() => vues().forEach(charger), 1200);
    if (document.readyState === 'complete') precharger();
    else addEventListener('load', precharger);

    /* Cliquer une vignette marquait bien la vue comme active, mais le
       carrousel ne s'y déplaçait pas : la grande image ne changeait pas.
       Le lien entre les deux est l'identifiant du média, porté par
       data-target sur la vignette et data-media-id sur la vue. */
    const piste = galerie.querySelector('.product__media-list');
    document.querySelectorAll('.thumbnail-list__item').forEach((vignette) => {
      vignette.addEventListener('click', () => {
        const cible = vignette.dataset.target;
        const vue = cible && galerie.querySelector('[data-media-id="' + cible + '"]');
        if (!vue || !piste) return;
        charger(vue);
        // Le carrousel est en « scroll-snap: x mandatory » : tant que
        // l'accroche est active, scrollTo et scrollLeft n'ont aucun effet,
        // la piste revient aussitôt à la vue courante. On la désactive le
        // temps du saut, puis on la rend — le navigateur cale alors sur la
        // vue qu'on vient d'atteindre.
        const snap = piste.style.scrollSnapType;
        const doux = piste.style.scrollBehavior;
        piste.style.scrollSnapType = 'none';
        piste.style.scrollBehavior = 'auto';
        piste.scrollLeft = vue.offsetLeft - piste.offsetLeft;
        requestAnimationFrame(() => {
          piste.style.scrollSnapType = snap;
          piste.style.scrollBehavior = doux;
        });
        // Le liseré ambre suit la vue affichée : c'est le thème qui le
        // posait, et on ne passe plus par lui.
        document.querySelectorAll('.thumbnail-list__item .thumbnail')
          .forEach((b) => b.setAttribute('aria-current', 'false'));
        const bouton = vignette.querySelector('.thumbnail');
        if (bouton) bouton.setAttribute('aria-current', 'true');
        setTimeout(autour, 200);
      });
    });
  }

  /* ── l'en-tête qui revient quand on remonte ────────────────────────── */
  /* <sticky-header data-sticky-type="on-scroll-up"> : chez eux, l'en-tête
     disparaît quand on descend et se recolle en haut dès qu'on remonte, sans
     avoir à revenir au sommet de la page. Le comportement vivait dans le
     moteur de leur thème, que nous n'utilisons pas. Les classes et la
     transition, elles, sont déjà dans la feuille de style reprise. */
  if (!customElements.get('sticky-header')) {
    class EnteteCollante extends HTMLElement {
      connectedCallback() {
        this.entete = document.querySelector('.section-header');
        if (!this.entete) return;
        this.dernier = 0;
        this.bas = this.entete.getBoundingClientRect().bottom + window.scrollY;

        this.mesurer = () => {
          const h = Math.round(this.entete.getBoundingClientRect().height);
          if (h) document.documentElement.style.setProperty('--header-height', h + 'px');
        };
        this.mesurer();
        addEventListener('resize', this.mesurer);

        this.auDefilement = this.auDefilement.bind(this);
        addEventListener('scroll', this.auDefilement, { passive: true });
      }

      disconnectedCallback() {
        removeEventListener('scroll', this.auDefilement);
        removeEventListener('resize', this.mesurer);
      }

      auDefilement() {
        const y = window.scrollY;
        const c = this.entete.classList;
        const h = this.entete.offsetHeight;

        if (y <= this.bas) {
          // de retour en haut : l'en-tête reprend sa place dans le flux
          c.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
          this.entete.style.removeProperty('position');
          this.entete.style.removeProperty('top');
        } else if (y > this.dernier) {
          // on descend : il s'efface vers le haut
          c.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
          this.poser(-h);
        } else if (y < this.dernier) {
          // on remonte : il redescend en haut de l'écran
          c.add('shopify-section-header-sticky', 'animate');
          c.remove('shopify-section-header-hidden');
          this.poser(0);
        }
        this.dernier = y;
      }

      /* On écrit le décalage en clair plutôt que de s'en remettre aux seules
         classes : selon l'ordre de chargement des feuilles reprises, la règle
         qui porte `top` n'est pas toujours celle qui gagne. */
      poser(haut) {
        this.entete.style.setProperty('position', 'sticky', 'important');
        this.entete.style.setProperty('top', haut + 'px', 'important');
      }
    }
    customElements.define('sticky-header', EnteteCollante);
  }

  /* ── rappels d'achat : ils remontent au bloc d'offres ───────────────── */
  document.querySelectorAll('[data-hs-rappel]').forEach((bouton) => {
    bouton.addEventListener('click', () => {
      const cible =
        document.querySelector('[data-offres]') ||
        document.querySelector('.kaching-bundles') ||
        document.querySelector('.product__info-container');
      if (!cible) return;
      cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });


  /* ── La barre collante doit passer par le vrai bouton ──────────────────
     Son bouton porte « form="product-form-…" » : le navigateur soumet donc le
     formulaire produit, qui n'ajoute qu'un article et aucun cadeau. Le module
     d'offres (assets/offres.js) écoute le clic sur « .atc-button », pas la
     soumission. On fait donc cliquer la barre sur ce bouton-là.
     Le reste — taille cochée d'avance, formule par défaut, bouton jamais
     grisé — est géré dans offres.js, à la source. */
  (function () {
    const barre = document.querySelector('sticky-atc button[name="add"]');
    const vrai = document.querySelector('.atc-button');
    if (!barre || !vrai) return;
    barre.removeAttribute('form');
    barre.type = 'button';
    barre.addEventListener('click', (evenement) => {
      evenement.preventDefault();
      vrai.click();
    });
  })();

})();
